//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tool from '@/axios/tool'
// import { ifError } from 'assert'
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      socket: null,
      showClose: false,
      activeName: '9999',
      activeIndex: 0,
      treePlateList: [],

      tabbars: [
        {
          name: '/home',
          title: '首页',
          icon: 'wap-home-o'
        },
        {
          name: '/companyProduct',
          title: '产品',
          icon: require('@/assets/images/chanping.png')
        },
        {
          name: '/jobFair',
          title: '招聘会',
          icon: 'wap-nav'
        },

        {
          name: '/myComponents',
          title: '我的',
          icon: 'manager-o'
        }

      ],
      token: '2'

    }
  },
  watch: {
    $route(newName, oldNmae) {
      if (oldNmae.name === 'login') {
        // this.getTreePlate()
      }
    },
    token(val) {
      window.parameter.token = val
      window.token = val
    }
  },
  created() {
    this.getToken()
    this.$fetch.getTenantByDomainArray().then(item => {
      // this.getWebsiteByDomainArray()
    })
  },
  mounted() {
    console.log(this.activeName, 32131)
    const href = window.location.href
    const w = href.indexOf('?')
    const j = href.indexOf('#')
    // 处理微信回调url
    if (w !== -1 && j > w) {
      // console.log(href.substr(0, w), 123456)
      // console.log(href.substr(j, href.length), 22222222)
      // console.log(location.search, 33333)
      // console.log(href.substr(w + 1, j - (w + 1)), 5555)
      // const hrefs = href.substr(0, w) + href.substr(j, href.length) + location.search + '?' + href.substr(w + 1, j - (w + 1))
      const arrCode = href.substr(w + 1, j - (w + 1))
      const a = arrCode.indexOf('&')
      const code = arrCode.substr(5, a)
      const state = arrCode.substring(a + 7, arrCode.length)
      this.getCodeBtn(code, state)
    }
  },
  methods: {

    getToken() {
      window.vm = this
      window['qcTakeTokenResult'] = this.qcTakeTokenResult
      if (this.$ua.isIosApp) {
        window.webkit &&
          window.webkit.messageHandlers.takeTokenResult.postMessage(null)
      }
      if (this.$ua.isAndroidApp) {
        var token = window.QCWLAndroid.takeTokenResult()
        this.token = token
        sessionStorage.setItem('token', token)
        window.parameter.token = token
        window.token = token
        window.localStorage.setItem('token3', token)
      }
    },

    qcTakeTokenResult(token) {
      window.vm.title = token
      window.parameter.token = token
      sessionStorage.setItem('token', token)
    },
    onChange(index) {
      this.activeIndex = index
      console.log(this.activeIndex, ';;s;;s;s;s;;')
    },
    // tabber改变事件
    onChangeTabber(index) {
      if (this.treePlateList[index].linkUrl && !this.treePlateList[index].havePlateData) {
        this.linkBtn(this.treePlateList[index])
        return
      }
      this.$router.push({
        path: '/home',
        query: {
          previewId: this.$route.query.previewId,
          lightIndex: index,
          plateId: this.treePlateList[index].id
        }
      })
    },
    // 返回首页
    onBack() {
      this.$router.push({
        path: '/home'
      })
    },
    // 点击跳转
    linkBtn(item) {
      if (!item.linkUrl) {
        return
      }
      if (item.linkUrl === '#') {
        return
      }
      var returnUrl = encodeURIComponent(
        `http://${window.location.host}`
      )
      var linkLocalHost = ``
      if (item.linkUrl.indexOf('?') != -1) {
        linkLocalHost = `&returnUrl=${returnUrl}`
      } else {
        linkLocalHost = `?returnUrl=${returnUrl}`
      }
      if (item.loginFlag) {
        if (!this.$store.state.token.data.token) {
          this.$message.error({
            showClose: true,
            message: '请先登录再进行此操作！'
          })

          this.$router.push({
            path: '/login',
            query: {
              returnUrl: `${item.linkUrl}` + linkLocalHost,
              productCode: item.appCode,
              productUrl: item.linkUrl
            }
          })
          return
        } else {
          this.loginSubsystem(item)
        }
      } else {
        if (item.ifWindowOpen == 1) {
          window.open(item.linkUrl + linkLocalHost)
        } else {
          window.location.href = item.linkUrl + linkLocalHost
        }
      }
    },
    // // 获取模块列表
    // async getTreePlate() {
    //   const d = await this.post(this.$api.customWeb.treePlate, {
    //     preview: this.$route.query.previewId,
    //     websiteId: this.$common.getLocalStorage('websiteId')
    //   })

    //   if (d.code === 0) {
    //     this.treePlateList = d.data
    //     // document.body.style.setProperty('--iconColor', this.$store.state.home.data.styleJo.sizeColor)
    //     // document.body.style.setProperty('--mianColor', this.$store.state.home.data.styleJo.mianColor)
    //     // document.body.style.setProperty('--selectBackgroundColor', this.$store.state.home.data.styleJo.selectBackgroundColor)
    //     // document.body.style.setProperty('--selectSizeColor', this.$store.state.home.data.styleJo.selectSizeColor)
    //     // document.body.style.setProperty('--backgroundColor', this.$store.state.home.data.styleJo.backgroundColor ? this.$store.state.home.data.styleJo.backgroundColor : '#ffffff')
    //     // document.body.style.setProperty('--sizeColor', this.$store.state.home.data.styleJo.sizeColor ? this.$store.state.home.data.styleJo.sizeColor : '#999999')
    //     this.activeIndex = Number(this.$route.query.lightIndex) || 0
    //     if (this.$route.query.plateId) {
    //       sessionStorage.setItem('lightIndex', this.$route.query.lightIndex)
    //     } else {
    //       // 禁止刷新跳转首页
    //       if (this.$route.name === 'login' || this.$route.name === 'register' || this.$route.name === 'moreNewsList' || this.$route.name === 'myComponents' ||
    //         this.$route.name === 'changePassword' || this.$route.name === 'setComponent' || this.$route.name === 'updatapwd' || this.$route.name === 'newDetailList' ||
    //         this.$route.name === 'enter' || this.$route.name === 'paymentRecords' || this.$route.name === 'enterList' || this.$route.name === 'addInfo'
    //       ) {
    //         console.log(33)
    //       } else {
    //         if (this.treePlateList[0].linkUrl && !this.treePlateList[0].havePlateData) {
    //           this.linkBtn(this.treePlateList[0])
    //           return
    //         }
    //         this.$router.push({
    //           path: '/home',
    //           query: {
    //             previewId: this.$route.query.previewId,
    //             lightIndex: 0,
    //             plateId: this.treePlateList[0].id
    //           }
    //         })
    //       }
    //     }
    //   }
    // },

    async getWebsiteByDomainArray() {
      const dev = process.env.NODE_ENV == 'development'
      const d = await this.post(this.$api.customWeb.getWebsiteByDomainArray, {
        domainArray: dev ? '10.0.0.22:30563' : window.location.host,
        tenantId: tool.getLocalStorage('tenantId') || ''

      }, false)
      if (d.code === 0) {
        this.$common.setLocalStorage('websiteId', d.data.id)
        setTimeout(() => {
          // this.getTreePlate()
          this.getUniversityHome()
        }, 1000)
      }
    },
    async getUniversityHome() {
      const d = await this.post(this.$api.customWeb.getConfiguration, {
        websiteId: this.$common.getLocalStorage('websiteId') || ''

      }, false)
      if (d.code === 0) {
        // console.log(this.$route.meta.title, 'this.router.meta.title')
        window.document.title = d.data.browserDisplay
        if (d.data.browserDisplay) {
          window.document.title = d.data.browserDisplay
        } else {
          window.document.title = d.data.websiteTitle
        }
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = d.data.favicon
        if (d.data.styleJo === null) {
          d.data.styleJo = {
            sizeColor: '#ffffff',
            selectSizeColor: '#ffffff',
            backgroundColor: '#1e46d2',
            selectBackgroundColor: '#ffffff'
          }
        }
        document.getElementsByTagName('head')[0].appendChild(link)
        this.$store.dispatch('setHome', d.data)
      }
    },
    goLoginBtn() {
      this.$router.push({ path: 'login' })
    },
    closeBtn() {
      this.showClose = true
    },
    async getCodeBtn(code, state) {
      const d = await this.post(this.$api.common.getWeChatOpenId, {
        code: code,
        state: state,
        getWeChatOpenId: this.$store.state.token.data.token
      })
      if (d.code === 0) {
        localStorage.setItem('openId', d.data.openId)
        // window.location.href = window.location.host + `/#/home?code=${code}&state=${state}`
      }
    },
    // tab点击切换页面
    handleTabClick(index, tabName) {
      this.currentIndex = index
      this.$router.push(tabName)
    }

  }
}



// WEBPACK FOOTER //
// ./src/App.vue